import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import { environment } from '../../../../environments/environment';

const API_URL = environment.apiUrl;

@Injectable()
export class MovementService {

    entity: string;

    constructor(private http: Http) {
    }

    public countOpen() {
        return this.http
            .get(API_URL + '/Movements/CountOpenMovements/1')
            .map(response => response.json())
            .catch(this.handleError);
    }

    private handleError(error: Response | any) {
        console.error('ApiService::handleError', error, this.entity);
        return Observable.throw(error);
    }

}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/base/backoffice/movements/movement.service.ts